export type FlocktoryWindow = typeof window & {
  flocktory?: FlocktoryApi | FlocktoryQueue;
};

type FlocktoryQueue = unknown[] & {
  push?: (...args: unknown[]) => number;
  reInit?: () => void;
  getData?: () => unknown;
};

interface FlocktoryApi {
  push: (...args: unknown[]) => void;
  reInit?: () => void;
  getData?: () => unknown;
}

export const getFlocktoryWindow = (): FlocktoryWindow =>
  window as FlocktoryWindow;

export const getFlocktoryQueue = (): FlocktoryQueue => {
  const flocktoryWindow = getFlocktoryWindow();

  if (!flocktoryWindow.flocktory) {
    flocktoryWindow.flocktory = [];
  }

  return flocktoryWindow.flocktory as FlocktoryQueue;
};
